import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../LabelText';

const Name = (props) => {
	const { t } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);
	const lineUserData = useSelector(state => state.lineUserData);
	const userData = useSelector(state => state.userData);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;

	const [inputValue, setInputValue] = useState('');

	const registerField = () => {
		// For Shopcarts controller, only use global validator
		// For other controllers, use Redux store validator
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		console.log('validator', validator);
		
		if (validator && form_component.required) {
			const fieldName = controller === 'Shopcarts' ? 'buyer_name' : 'name';
			
			try {
				// Check if field already exists and remove it first
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				console.log('Adding field:', fieldName);
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					// Explicitly specify the element selector
					selector: `input[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => { // to be updated after render
		registerField();
	}, [fv, controller, form_component.required, t]);

	// Listen for FormValidation reinitialization
	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t]);

	useEffect(() => { // to be updated after render
		// Only update if we have actual data and the field is currently empty
		// This prevents clearing existing user input
		if (!inputValue || inputValue.trim() === '') {
			if (userData && userData.name && userData.name.trim() !== '') {
				setInputValue(userData.name);
			} else if (lineUserData && lineUserData.nickname && lineUserData.nickname.trim() !== '') {
				setInputValue(lineUserData.nickname);
			}
		}
	}, [lineUserData, userData, inputValue]);

	const onChange = (e) => {
		const value = e.target.value;
		setInputValue(value);
		
		// Force update DOM value for FormValidation
		if (controller === 'Shopcarts') {
			const fieldName = 'buyer_name';
			const domElement = document.querySelector(`input[name="${fieldName}"]`);
			if (domElement) {
				domElement.setAttribute('value', value);
				domElement.value = value;
			}
		}
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			<input
				type="text"
				name={controller === 'Shopcarts' ? 'buyer_name' : 'name'}
				placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
				className="form-control-sm mb-3 form-control"
				id={controller === 'Shopcarts' ? 'buyer-name' : 'name'}
				value={inputValue}
				onChange={onChange}
			/>
		</div>
	);
}

export default Name;